import { Tag, Typography } from 'antd';
import { formatVND } from '@/utils/format';
import type { ComboPriceBlock } from '../utils/comboMatcher';

const { Text } = Typography;

interface Props {
  blocked: ComboPriceBlock;
}

/**
 * Dòng giải thích vì sao một combo khớp đủ hàng trong giỏ mà KHÔNG được gợi ý.
 *
 * Luật chặn (xem `matchCombos`): không gợi ý combo nào làm TĂNG giá của một
 * dòng đang có trong giỏ — `retail_price` trong định nghĩa combo là ảnh chụp
 * lúc cấu hình, giá thật có thể đã thấp hơn giá phân bổ. Luật đúng, nhưng
 * trước đây nó im lặng: thu ngân nhìn thấy đủ hàng của một combo đang chạy,
 * không có banner nào, và không có cách nào biết vì sao (ca thật gặp phải: một
 * thành phần bị để giá 0đ nên mọi giá phân bổ đều là "tăng").
 *
 * KHÔNG có nút "Áp dụng": áp vào sẽ đẩy giá dòng lên đúng cái mà luật đang
 * chặn. Đường sửa nằm ở bảng giá sản phẩm hoặc ở cấu hình combo, không phải ở
 * đây — nên đây chỉ là thông tin.
 */
export function ComboBlockedHint({ blocked }: Props) {
  return (
    <div
      data-testid="pos-combo-blocked-hint"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        background: '#fffbe6',
        border: '1px solid #ffe58f',
        borderLeft: '3px solid #faad14',
        borderRadius: 5,
        padding: '8px 11px',
        margin: '0 12px 6px',
        flexShrink: 0,
      }}
    >
      <Tag color="#faad14" style={{ margin: 0, fontSize: 10, fontWeight: 700, flexShrink: 0 }}>
        COMBO
      </Tag>
      <Text style={{ fontSize: 13 }}>
        Giỏ có đủ hàng của{' '}
        <Text strong>
          {blocked.unit_count}× {blocked.combo_name}
        </Text>{' '}
        (tiết kiệm {formatVND(blocked.saving)}) nhưng chưa gộp được — giá đang bán thấp hơn giá
        trong combo, gộp vào sẽ làm dòng hàng ĐẮT lên:{' '}
        {blocked.lines.map((line, idx) => (
          <Text key={line.itemId} type="secondary" style={{ fontSize: 13 }}>
            {idx > 0 && '; '}
            <Text strong style={{ fontSize: 13 }}>
              {line.productName}
            </Text>{' '}
            đang {formatVND(line.currentPrice)} → trong combo {formatVND(line.comboPrice)}
          </Text>
        ))}
        . Sửa giá bán sản phẩm hoặc giá combo để dùng được.
      </Text>
    </div>
  );
}
